module.exports = __webpack_public_path__ + "static/media/Map Page@2x.98a7a431.png";